const unknownErrorV2 = 'Unknown Error'

const status = function (error) {
  if (!error || !error.response || !error.response.status) {
    return 0
  }

  return error.response.status
}

const message = function (error) {
  if (!error || !error.response || !error.response.data || !error.response.data.message) {
    return unknownErrorV2
  }

  return error.response.data.message
}

export default class extends Error {
  constructor (error) {
    super(message(error))
    this.status = status(error)
    this.code = 0 // future error code support
  }
}
